import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

const Carousel = () => {
    new Swiper('.swiper', {
        direction: 'horizontal',
        spaceBetween: 24,
        slidesPerView: 1.5,

        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
        },
        navigation: {
            nextEl: '.carousel__button--next',
            prevEl: '.carousel__button--prev',
        },
    });
};

export default Carousel;
